export default function (state) {
    let form = state.form;
    let data = {};

    switch (form.dateType) {
        case 1:
            if (form.dates[0]) data.PlannedPaymentDateFrom = {Serialized: form.dates[0]};
            if (form.dates[1]) data.PlannedPaymentDateTo = {Serialized: form.dates[1]};
            break;
        case 2:
            if (form.dates[0]) data.AccountDateFrom = {Serialized: form.dates[0]};
            if (form.dates[1]) data.AccountDateTo = {Serialized: form.dates[1]};
            break;
        case 3:
            if (form.dates[0]) data.CreateDateFrom = {Serialized: form.dates[0]};
            if (form.dates[1]) data.CreateDateTo = {Serialized: form.dates[1]};
            break;
    }
    if (form.CurrencyId.length) data.CurrencyId = form.CurrencyId;
    if (form.PaymentTypeIds.length) data.PaymentTypeIds = form.PaymentTypeIds;
    if (form.CashList.length) data.CashList = form.CashList;
    if (form.PaymentAccountList.length) data.PaymentAccountList = form.PaymentAccountList;
    if (form.CategoryId || form.CategoryId === 0) data.CategoryId = form.CategoryId;

    if (form.AgreementCode) data.AgreementCode = form.AgreementCode;
    if (form.PaymentOperationId) data.PaymentOperationId = form.PaymentOperationId;
    if (form.ContragentId) {
        data.ContragentId = form.ContragentId;
        data.ContragentSearchTypeId = form.ContragentSearchTypeId;
    }
    if (form.InvoiceSumFrom) data.InvoiceSumFrom = form.InvoiceSumFrom;
    if (form.InvoiceSumTo) data.InvoiceSumTo = form.InvoiceSumTo;
    if (form.OnlyOverdue) data.OnlyOverdue = form.OnlyOverdue;
    if (form.AccountNumber) data.AccountNumber = form.AccountNumber;


    if (form.ManagerList.length) data.ManagerList = form.ManagerList;
    if (form.DepartmentList.length) data.DepartmentList = form.DepartmentList;
    if (form.PayStates.length) data.PayStates = form.PayStates;
    if (form.KindOfPayId) data.KindOfPayId = form.KindOfPayId;
    return data;
}